import { jsx as _jsx } from "react/jsx-runtime";
import noop from "lodash/noop";
import { createContext, useContext, useMemo, useRef } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
const defaultValue = {
    subscribe: ()=>({
            unsubscribe: noop
        }),
    updateTime: noop,
    getCurrentTime: ()=>null
};
const VideoTimestampObserverContext = /*#__PURE__*/ createContext(defaultValue);
export const VideoTimestampObserverProvider = (param)=>{
    let { children } = param;
    const currentTime = useRef(null);
    const observers = useRef([]);
    const value = useMemo(()=>({
            updateTime: (timeInSeconds)=>{
                currentTime.current = timeInSeconds;
                observers.current.forEach((observer)=>observer(currentTime.current));
            },
            subscribe: (observer)=>{
                observers.current.push(observer);
                return {
                    unsubscribe: ()=>{
                        observers.current = observers.current.filter((o)=>o !== observer);
                    }
                };
            },
            getCurrentTime: ()=>currentTime.current
        }), []);
    return /*#__PURE__*/ _jsx(VideoTimestampObserverContext.Provider, {
        value: value,
        children: children
    });
};
export const useVideoTimestampObserverContext = ()=>{
    const context = useContext(VideoTimestampObserverContext);
    if (context === defaultValue) {
        const error = "useVideoTimestampObserverContext must be used within a VideoTimestampObserverProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
